import { IModifierGroupsContext, IFilterValues } from './modifierGroupsContext';

export enum ModifierGroupsActionTypes {
	SET_MODIFIER_GROUPS = 'SET_MODIFIER_GROUPS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetModifierGroups {
	type: ModifierGroupsActionTypes.SET_MODIFIER_GROUPS;
	payload: {
		modifiersGroups: IModifierGroupsContext['modifiersGroups'];
		typeOfModalWindow: IModifierGroupsContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: ModifierGroupsActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IModifierGroupsContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: ModifierGroupsActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IModifierGroupsContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: ModifierGroupsActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IModifierGroupsContext['IDSelectedRestaurant'];
	};
}

interface IResetSelectedControls {
	type: ModifierGroupsActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: ModifierGroupsActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IModifierGroupsContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ModifierGroupsActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IModifierGroupsContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: ModifierGroupsActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IModifierGroupsContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: ModifierGroupsActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IModifierGroupsContext['IDForDeletion'];
		typeOfModalWindow: IModifierGroupsContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IModifierGroupsContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: ModifierGroupsActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TModifierGroupsAction =
	| ISetModifierGroups
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
